import React, { useState, useEffect } from 'react'
import Header from '../components/Header'
import HierarchyTree from '../components/HierarchyTree'
import { fetchAndBuildHierarchy } from '../utils/hierarchyBuilder'

export default function ManagementPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
     fetchAndBuildHierarchy('management').then(res => {
         if (res) setData(res);
     });
  }, []);

  return (
    <div>
        <Header title={'Management'} />
        {data ? (
            <HierarchyTree 
                data={data} 
                title="Meet Our Board of Directors & Management" 
                subtitle="Our Management"
            />
        ) : (
            <div className="text-center py-5 text-muted">
                <p>Loading hierarchy or list is empty...</p>
            </div>
        )}
    </div>
  )
}
